// extracted by mini-css-extract-plugin
export default {"toggle":"select-people_toggle__t7I8+"};